import { Box, Divider, useTheme } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Typography from "../Typography/Typography";

interface OrganizationUsersProps {
	title: string;
	paddingX: number;
	paddingTop: number;
	paddingBottom?: number;
	endAdornment?: () => JSX.Element;
}

const InfoDivider: React.FC<OrganizationUsersProps> = ({ title, paddingX, paddingBottom, paddingTop, endAdornment }) => {
	const {
		typography: { pxToRem },
	} = useTheme();
	const { t } = useTranslation();

	return (
		<Box
			width="100%"
			paddingX={paddingX}
			paddingTop={paddingTop}
			paddingBottom={paddingBottom}
			display="flex"
			justifyContent="space-between"
			alignItems="center"
		>
			<Typography type="h7" style={{ color: "#0b5a65" }}>
				{t(title)}
			</Typography>
			<Divider style={{ flexGrow: 1, margin: pxToRem(15), backgroundColor: "#0b5a65" }} />
			{!!endAdornment && endAdornment()}
		</Box>
	);
};

export default InfoDivider;
